import { render, staticRenderFns } from "./FreightTerms.vue?vue&type=template&id=7e65c436&scoped=true"
import script from "./FreightTerms.vue?vue&type=script&lang=js"
export * from "./FreightTerms.vue?vue&type=script&lang=js"
import style0 from "./FreightTerms.vue?vue&type=style&index=0&id=7e65c436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e65c436",
  null
  
)

export default component.exports